import * as React from 'react';

import type Moment from 'moment';

import {LAST_365_DAYS} from 'nutshell-core/constants';
import {safelyGetFilterByKey} from 'nutshell-core/filter';
import type {FilterObject, ComparisonRangeType} from 'nutshell-core/types';

import {DateRangePicker} from 'shells/date-range-picker/date-range-picker';

import type {DateRangeType} from './report-types';

import styles from './report-date-range-picker.module.css';

type Props = {
    dateRangeType: DateRangeType;
    dateRangeOptions: {
        id: string;
        value: string;
    }[];
    activeFilters: FilterObject[];
    comparisonType?: ComparisonRangeType;
    onDateRangeChange: (arg1: FilterObject, comp?: ComparisonRangeType) => any;
    hideCompareTo?: boolean;
    // @ts-expect-error
    minDate?: Moment;
    // @ts-expect-error
    maxDate?: Moment;
};

export class ReportDateRangePicker extends React.PureComponent<Props> {
    render() {
        const dateRangeFilter = safelyGetFilterByKey(
            this.props.activeFilters,
            this.props.dateRangeType
        );

        return (
            // id is used in tours, do not change without updating tour.ts
            <div className={styles['report-date-range-picker']} id='report-date-range-picker'>
                <DateRangePicker
                    filter={
                        typeof dateRangeFilter === 'string' ? dateRangeFilter : LAST_365_DAYS.id
                    }
                    dateRangeOptions={this.props.dateRangeOptions}
                    comparisonType={this.props.comparisonType}
                    onChange={this.handleDateRangeChange}
                    hideCompareTo={this.props.hideCompareTo}
                    minDate={this.props.minDate}
                    maxDate={this.props.maxDate}
                />
            </div>
        );
    }

    /**
     * Helper function to look up a dynamic filter type based on the date
     * range leadBin being used. Creates a fitlerObj and calls props.onDateRangeChange
     * together with an optional comparison range type
     *
     * @param  {string} dateFilter       - New date range returned from our datePicker
     * @param  {string} [comparisonType] - Compare by previous period or previous year
     * @return {void}
     */
    handleDateRangeChange = (dateFilter: string, comparisonType?: ComparisonRangeType) => {
        const newDateFilter = {[this.props.dateRangeType]: dateFilter} as const;
        this.props.onDateRangeChange(newDateFilter, comparisonType);
    };
}
